import React from "react";
import Canvas3D from "./Canvas3D";
import DartGame from "./DartGame";
import Hero from "./Sections/Hero";
import About from "./Sections/About";
import Work from "./Sections/Work";
import Contact from "./Sections/Contact";
import "../styles/LandingPage.css";

export default function LandingPage() {
  return (
    <div className="app">
      <header className="banner">
        <div className="banner-content">
          <div className="banner-canvas">
            <Canvas3D />
          </div>
          <DartGame />
        </div>
      </header>

      <main className="content">
        <Hero />
        <About />
        <Work />
        <Contact />
      </main>
    </div>
  );
}

